// reactstrap components
import { Container, Row } from "reactstrap";
// core components
import Header from "../../../components/Headers/Header.js";
import OpenResponses from "../../../components/OpenResponses.js";

const Responses = () => {
  return (
    <>
      <Header
        title="Open Responses"
        description="Survey responses Description"
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <OpenResponses />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Responses;
